import api from "../helpers/api"

class Activity{

    async getActivities(){
        return await api.get('/activities').then(
            response =>{
                return response.data
            }
        )
    }
}

export default new Activity